<template>
  <div v-if="!processing && !isCPLoading" class="cp-section__list">
    <div class="cp-subheading mt-0" :class="{'d-none d-md-block': !isHome}">
      <div v-if="input">{{input.formatted_label | stripHTML}}</div>
      <div v-else>{{title}}</div>
    </div>
    <div class="cp__orders__container">
      <b-card no-body v-if="!hasOrders" class="cp__order no__orders" :class="{'active-orders': activeOrders}">
        <template v-if="isHome">
          <p class="no__orders__description">You have no recent orders.</p>
          <p class="no__orders__description">Check out our popular products to get started!</p>
        </template>
        <template v-else-if="activeOrders">
          <p class="no__orders__description">There are no upcoming orders to display. <b-link v-if="orderHistorySideMenu" @click.stop="goToOrderHistory()" class="theme-text">View your past orders</b-link></p>
          <p class="no__orders__description">
            <template v-if="!orderHistorySideMenu">C</template>
            <template v-else>or c</template>heck out our popular products to get started!
          </p>
        </template>
        <template v-else-if="orderHistory">
          <p class="no__orders__description">You haven't placed any orders yet.</p>
          <p class="no__orders__description">You'll be able to see your order history and reorder your favorites here.</p>
        </template>
      </b-card>
      <template v-else>
        <OrderTile
          v-for="order in orders"
          :order="order" :key="'order' + order.order_id"
          :order-again="isHome"
        />
      </template>
    </div>
  </div>
  <ProcessingLoader v-else />
</template>

<script>

import axios from 'axios'
import {sortItems} from '@/utils'
import {mapState} from 'vuex'
import {InputType} from '@/constants'
const OrderTile = () => import('./OrderTile')
const ProcessingLoader = () => import('@/components/ProcessingLoader')

export default {
  name: 'OrderList',
  components: {ProcessingLoader, OrderTile},
  props: {
    title: String,
    limit: Number,
    input: Object,
    params: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      orders: [],
      processing: true
    }
  },
  computed: {
    ...mapState(['session', 'isCPLoading', 'customerPortalSettings']),
    isHome: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalHome
    },
    activeOrders: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrders
    },
    orderHistory: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrderHistory
    },
    hasOrders: function() {
      return this.orders && this.orders.length > 0
    },
    orderHistorySideMenu: function() {
      const allSideMenus = (this.session && this.session.side_menu_inputs) || []
      let availableSideMenus = (this.customerPortalSettings && this.customerPortalSettings.side_menu_inputs) || []
      availableSideMenus = allSideMenus.filter((sideMenu) => availableSideMenus.indexOf(sideMenu.type) > -1)
      return availableSideMenus.find((sideMenu) => sideMenu.type === InputType.CustomerPortalOrderHistory)
    }
  },
  methods: {
    updateStatus: function() {
      // update the select all checkbox
      this.canContinue = Object.keys(this.orders).length !== 0
      this.orders = this.orders.slice() // force item statuses to be called
    },
    fetchOrders: function(params = {}) {
      this.$store.commit('showLoader')
      axios.get('/order_items/', {params}).then(result => {
        let items = result.data.results
        let lastOrderId = null
        let orders = []
        let order = {}
        let startIndex = 0

        sortItems(items)

        for (let i = 0; i < items.length; i++) {
          let orderId = items[i].order.id

          if (orderId !== lastOrderId) { // if this is the 1st item of a different order
            if (i > 0) {
              // if this is not the 1st item, then copy the items from the previous order
              order['items'] = items.slice(startIndex, i)
              orders.push(order)
            }

            lastOrderId = orderId
            if (orders.length === +this.limit) {
              break
            }
            startIndex = i
            order = {
              id: items[i].order.id,
              order_id: items[i].order.order_id,
              created: items[i].order.created,
              subtotal: items[i].order.subtotal,
              shipping_price: items[i].order.shipping_price,
              hidden_fees: items[i].order.hidden_fees,
              tax: items[i].order.tax,
              charged: items[i].order.amount_charged,
              paid: items[i].order.amount_paid,
              discount: items[i].order.discount,
              total: items[i].order.total_discounted_price,
              total_remaining_balance: items[i].order.total_remaining_balance,
              amount_due: items[i].order.amount_due,
              pending_refund: items[i].order.pending_refund_amount,
              refund: items[i].order.settled_refund_amount,
              chargeback: items[i].order.chargeback_amount,
              forward_balance: items[i].order.forward_balance,
              past_balance: items[i].order.past_balance,
              status: items[i].order.status,
              payment_status: items[i].order.payment_status,
              tip: items[i].order.tip,
              currency: items[i].order.currency,
              store_credit: items[i].order.store_credit,
              store_debit: items[i].order.store_debit
            }
          }

          if (i === (items.length - 1)) { // if this is the last item
            order['items'] = items.slice(startIndex)
            orders.push(order)
          }
        }

        this.orders = orders
        this.updateStatus()
        this.$store.commit('hideLoader')

        if (!items.length) {
          this.canContinue = true
        }
        this.processing = false
      }, error => {
        this.$store.commit('critical_error', error)
        this.$store.commit('hideLoader')
        this.processing = false
      })
    },
    goToOrderHistory: function() {
      this.$emit('submit', this.orderHistorySideMenu)
    }
  },
  created() {
    this.processing = true
    this.fetchOrders(this.params)
  }
}
</script>

<style scoped>

</style>
